// Helper de descarga de archivos binarios (Blob) en el navegador.
//
// El Excel se genera en el BACKEND (pandas/openpyxl) y llega como Blob vía
// axios (responseType: 'blob'). Esta utilidad crea un enlace temporal y
// dispara la descarga con el nombre indicado, liberando el object URL después.

/**
 * Dispara la descarga de un Blob con el nombre de archivo dado.
 * @param {Blob} blob - contenido binario recibido del backend.
 * @param {string} filename - nombre sugerido para el archivo descargado.
 */
export function downloadBlob(blob, filename) {
  if (!blob) return;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "export.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Liberar el object URL en el siguiente tick (evita abortar la descarga).
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

/**
 * Nombre de archivo con marca de tiempo local (YYYYMMDD-HHmm).
 * @param {string} prefix - prefijo del nombre (p. ej. "servicios-validacion").
 * @param {string} ext - extensión sin punto (default "xlsx").
 */
export function timestampedName(prefix, ext = "xlsx") {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const stamp =
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `-${pad(d.getHours())}${pad(d.getMinutes())}`;
  return `${prefix}-${stamp}.${ext}`;
}
